<template>
  <div class="min-h-screen">
    <Head title="Propietarios" />
    
    <!-- Header Section -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div class="flex items-center justify-between mb-6">
        <div class="flex items-center space-x-4">
          <button 
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
            @click="back()"
          >
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Volver
          </button>
          <h1 class="text-2xl font-bold text-gray-900">Propietarios</h1>
        </div>

        <!-- Action Buttons -->
        <div class="flex items-center space-x-2">
          <a 
            target="_blank" 
            :href="`/clientsReports/excel`" 
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 transition-colors duration-200"
          >
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            Excel
          </a>
          <a 
            target="_blank" 
            :href="`/clientsReports/pdf`" 
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 transition-colors duration-200"
          >
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 17h2a2 2 0 002-2v-4a2 2 0 00-2-2H5a2 2 0 00-2 2v4a2 2 0 002 2h2m2 4h6a2 2 0 002-2v-4a2 2 0 00-2-2H9a2 2 0 00-2 2v4a2 2 0 002 2zm8-12V5a2 2 0 00-2-2H9a2 2 0 00-2 2v4h10z" />
            </svg>
            PDF
          </a>
          <a 
            :href="`/clients/export`" 
            class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            download
          >
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
            </svg>
            Exportar
          </a>
          <div v-if="isMorochas" class="inline-flex rounded-md shadow-sm">
            <button 
              type="button"
              @click="copyGeneralLink" 
              class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-bold rounded-l-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
              title="Copiar enlace general para enviar a los propietarios por WhatsApp"
            >
              <svg v-if="!copiedGeneral" class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
              </svg>
              <svg v-else class="h-4 w-4 mr-2 text-green-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
              </svg>
              {{ copiedGeneral ? '¡Enlace Copiado!' : 'Copiar Link Actualizar Datos' }}
            </button>
            <a 
              target="_blank" 
              href="/actualizar-datos" 
              class="inline-flex items-center px-2.5 py-2 border-l border-indigo-700 text-sm leading-4 font-medium rounded-r-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              title="Abrir formulario público en una nueva pestaña"
            >
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
          <label class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-white bg-yellow-500 hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-500 transition-colors duration-200 cursor-pointer">
            <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
            </svg>
            Importar
            <input type="file" ref="importFile" class="hidden" @change="importClients" accept=".xlsx,.csv" />
          </label>
        </div>
      </div>

      <!-- Search and Create Section -->
      <div class="flex items-center justify-between mb-6">
        <search-filter v-model="form.search.search" class="w-full max-w-md" @reset="reset">
          <label class="block text-sm font-medium text-gray-700">Filtrar por calle:</label>
          <select 
            v-model="form.search.street_id" 
            class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md mb-4"
          >
            <option :value="null">Todas las calles</option>
            <option v-for="street in streets" :key="street.id" :value="street.id">{{street.name}}</option>
          </select>

          <label class="block text-sm font-medium text-gray-700">Filtrar por deuda:</label>
          <select 
            v-model="form.search.debt" 
            class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md mb-4"
          >
            <option value="">Todos</option>
            <option value="owes">Deudores</option>
            <option value="no_debt">Al día</option>
          </select>

          <label class="block text-sm font-medium text-gray-700">Ordenar por saldo adeudado:</label>
          <select 
            v-model="form.search.sort_by_balance" 
            class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
          >
            <option value="">Por defecto</option>
            <option value="desc">Mayor deuda primero</option>
            <option value="asc">Menor deuda primero</option>
          </select>
        </search-filter>

        <Link 
          href="/clients/create"
          class="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-200"
        >
          <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
          </svg>
          Crear Propietario
        </Link>
      </div>

      <!-- Table Section -->
      <div class="bg-white shadow-sm rounded-lg overflow-hidden">
        <div class="overflow-x-auto">
          <table class="min-w-full divide-y divide-gray-200">
            <thead class="bg-gray-50">
              <tr>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nombre</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Alias o Cédula</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Cuotas</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Correo</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Calle</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Apartado</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Dirección</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Adeudado</th>
                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Teléfono</th>
                <th scope="col" class="relative px-6 py-3">
                  <span class="sr-only">Acciones</span>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-200">
              <tr v-for="client in clients.data" 
                  :key="client.id" 
                  :class="[
                    'hover:bg-gray-50 transition-colors duration-150',
                    client.balance > 0 ? 'bg-red-50' : ''
                  ]"
              >
                <td class="px-6 py-4 whitespace-nowrap">
                  <Link :href="`/clients/${client.id}`" class="flex items-center text-sm font-medium text-indigo-600 hover:text-indigo-900">
                    {{ client.name }}
                    <icon v-if="client.deleted_at" name="trash" class="ml-2 h-4 w-4 text-gray-400" />
                  </Link>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ client.identification }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-500">
                  <div class="flex flex-col space-y-1">
                    <template v-if="client.orders.length <= 3">
                      <Link 
                        v-for="order in client.orders" 
                        :key="order.id" 
                        :href="`/orders/${order.id}`"
                        class="text-indigo-600 hover:text-indigo-900"
                      >
                        {{ order.number_order }}
                      </Link>
                    </template>
                    <template v-else>
                      <template v-if="expandedClients[client.id]">
                        <Link 
                          v-for="order in client.orders" 
                          :key="order.id" 
                          :href="`/orders/${order.id}`"
                          class="text-indigo-600 hover:text-indigo-900"
                        >
                          {{ order.number_order }}
                        </Link>
                        <button 
                          @click="toggleExpand(client.id)"
                          class="text-xs text-indigo-500 hover:text-indigo-700 font-bold focus:outline-none text-left mt-1"
                        >
                          Ver menos
                        </button>
                      </template>
                      <template v-else>
                        <Link 
                          v-for="order in client.orders.slice(0, 3)" 
                          :key="order.id" 
                          :href="`/orders/${order.id}`"
                          class="text-indigo-600 hover:text-indigo-900"
                        >
                          {{ order.number_order }}
                        </Link>
                        <button 
                          @click="toggleExpand(client.id)"
                          class="text-xs text-indigo-500 hover:text-indigo-700 font-bold focus:outline-none text-left mt-1"
                        >
                          + {{ client.orders.length - 3 }} más
                        </button>
                      </template>
                    </template>
                  </div>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ client.email }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ client?.street?.name }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ client.companyName }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ client.address }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span 
                    :class="[
                      'px-2 inline-flex text-xs leading-5 font-semibold rounded-full',
                      client.balance > 0 ? 'bg-red-100 text-red-800' : 'bg-green-100 text-green-800'
                    ]"
                  >
                    {{ client.balance }}$
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ client.phone }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium space-x-2">
                  <button 
                    v-if="isMorochas"
                    type="button"
                    @click="copyClientLink(client.id)"
                    class="text-indigo-400 hover:text-indigo-600 inline-block mr-2"
                    :title="copiedClientId === client.id ? '¡Enlace de este propietario copiado!' : 'Copiar enlace de actualización de este propietario'"
                  >
                    <svg v-if="copiedClientId !== client.id" class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                    </svg>
                    <svg v-else class="h-5 w-5 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                    </svg>
                  </button>
                  <Link 
                    :href="`/clients/${client.id}`"
                    class="text-indigo-500 hover:text-indigo-700 inline-block mr-2"
                    title="Ver Ficha y Registrar Pago"
                  >
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  </Link>
                  <Link 
                    :href="`/clients/${client.id}/edit`"
                    class="text-gray-400 hover:text-gray-600 inline-block"
                    title="Editar Propietario"
                  >
                    <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </td>
              </tr>
              <tr v-if="clients.data.length === 0">
                <td colspan="10" class="px-6 py-4 text-center text-sm text-gray-500">
                  No hay propietarios registrados.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Pagination -->
      <div class="mt-6">
        <pagination :links="clients.meta.links" />
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import SearchFilter from '@/Shared/SearchFilter'

export default {
  components: {
    Head,
    Icon,
    Link,
    Pagination,
    SearchFilter,
  },
  layout: Layout,
  props: {
    filters: Object,
    clients: Object,
    streets: Object
  },
  data() {
    return {
      expandedClients: {},
      copiedGeneral: false,
      copiedClientId: null,
      form: {
        search: {
          street_id: this.filters.street_id || "",
          search: this.filters.search || "",
          debt: this.filters.debt || "",
          sort_by_balance: this.filters.sort_by_balance || "",
        },
        trashed: this.filters.trashed,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/clients', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  computed: {
    isMorochas() {
      const acc = this.$page?.props?.auth?.user?.account;
      if (!acc) return false;
      const name = ((acc.name || '') + ' ' + (acc.reasonName || '')).toLowerCase();
      return name.includes('morocha') || acc.id === 1;
    }
  },
  methods: {
    back() {
      window.history.back();
    },
    reset() {
      this.form.search = {
        street_id: "",
        search: "",
        debt: "",
        sort_by_balance: ""
      };
      this.form.trashed = null;
    },
    toggleExpand(clientId) {
      this.expandedClients = {
        ...this.expandedClients,
        [clientId]: !this.expandedClients[clientId]
      };
    },
    copyGeneralLink() {
      const url = `${window.location.origin}/actualizar-datos`;
      this.copyToClipboard(url);
      this.copiedGeneral = true;
      setTimeout(() => {
        this.copiedGeneral = false;
      }, 2500);
    },
    copyClientLink(clientId) {
      const url = `${window.location.origin}/actualizar-datos?client_id=${clientId}`;
      this.copyToClipboard(url);
      this.copiedClientId = clientId;
      setTimeout(() => {
        this.copiedClientId = null;
      }, 2500);
    },
    copyToClipboard(text) {
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text);
        return;
      }
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
      } catch (err) {}
      document.body.removeChild(textArea);
    },
    importClients(e) {
      const file = e.target.files[0];
      if (!file) return;
      
      const formData = new FormData();
      formData.append('file', file);
    
      this.$inertia.post('/clients/import', formData, {
        onSuccess: () => {
          this.$refs.importFile.value = null;
        }
      });
    }
  },
}
</script>
